import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import React from 'react';
import ISSUE_DOCS from '../../../../temp/issues.json';
import { IS_APP_CODEAC } from '../../../constants/env';
export const IssueReference = ({ href, ruleId, tool, showDocs, onToggleDocs }) => {
    if (!href && ruleId !== "CodeDuplication") {
        return _jsx("span", { className: 'report-detail__reference', children: ruleId });
    }
    const hasExtendedDocs = ISSUE_DOCS.includes(`${tool}/${ruleId.replace('@typescript-eslint', 'typescript-eslint').replaceAll(' ', '')}`);
    if (hasExtendedDocs && IS_APP_CODEAC) {
        return _jsxs("a", { href: '#', target: '_blank', className: 'report-detail__reference', onClick: (event) => onToggleDocs(event, tool, ruleId), children: [ruleId, "\u00A0", _jsx("span", { className: clsx('issue__expand', showDocs && 'issue__expand--open') })] });
    }
    return _jsx("a", { href: href, target: '_blank', rel: 'noreferrer', className: 'report-detail__reference', children: ruleId });
};
